export default __webpack_public_path__ + "static/media/DataReadMe.9a490b3c.md";